export default __webpack_public_path__ + "static/media/lb-net.9ef42e2a.webp";